/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersstatactivehint3Inputs */

const en_partnersstatactivehint3 = /** @type {(inputs: Partnersstatactivehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published a listing, event or menu in the last 30 days`)
};

const de_partnersstatactivehint3 = /** @type {(inputs: Partnersstatactivehint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den letzten 30 Tagen einen Ort, eine Veranstaltung oder ein Menü veröffentlicht`)
};

/**
* | output |
* | --- |
* | "Published a listing, event or menu in the last 30 days" |
*
* @param {Partnersstatactivehint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersstatactivehint3 = /** @type {((inputs?: Partnersstatactivehint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersstatactivehint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersstatactivehint3(inputs)
	return de_partnersstatactivehint3(inputs)
});
export { partnersstatactivehint3 as "partnersStatActiveHint" }